import { render, staticRenderFns } from "./DeliveryNoteInfo.vue?vue&type=template&id=1b03b9d8&"
import script from "./DeliveryNoteInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports